<nav class="navbar navbar-expand-lg navbar-dark szz-navbar px-2 px-lg-5" role="navigation"
    aria-label="Glavna navigacija">
    <div class="container-fluid p-0">
        <a class="navbar-brand p-0" routerLink="/claim-inquiry">
            <img src="/assets/img/szz_logo-inverse.svg" alt="MOST – na seznam zaprosil" height="40" />
        </a>
        <button class="navbar-toggler" type="button" (click)="toggleSidebar.emit()"
            [attr.aria-expanded]="sidebarOpen()" aria-label="Odpri meni">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse justify-content-end" id="navbarUserMenu">
            <ul class="navbar-nav">
                <li class="nav-item dropdown">
                    <div ngbDropdown>
                        <button ngbDropdownToggle
                            class="btn btn-link nav-link text-white d-flex align-items-center px-0">
                            <i class="fa fa-user fa-fw me-2" style="color: #fff;"></i>
                            @if (model().fullName) {
                                <span class="d-none d-lg-inline">{{model().fullName}}</span>
                            }
                            <i class="fa fa-caret-down ms-2"></i>
                        </button>
                        <div ngbDropdownMenu class="dropdown-user">
                            <a ngbDropdownItem href="/mojszz"
                                class="border-bottom w-100 text-decoration-none px-3 py-2 text-dark d-inline-block">
                                <i class="fas fa-home me-2" style="font-size: 20px; color: #8e4058;"></i>
                                Moj SZZ
                            </a>
                            <a ngbDropdownItem (click)="onLogout()" (keydown.enter)="$event.preventDefault(); onLogout()" (keydown.space)="$event.preventDefault(); onLogout()" role="button" tabindex="0"
                                class="text-decoration-none w-100 px-3 py-2 text-dark d-inline-block">
                                <i class="fas fa-sign-out-alt me-2" style="font-size: 20px; color: #8e4058;"></i>
                                Odjava
                            </a>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</nav>